import TankSquad from "../../pages/ProjectsPages/TankSquad/TankSquadPage";
import CastleFlipper from "../../pages/ProjectsPages/CastleFlipper/CastleFlipperPage";
import TBA from "../../pages/ProjectsPages/TBA/TBAPage";
import ExtractionShooter from "../../pages/ProjectsPages/ExtractionShooter/ExtractionShooterPage";
import InteractiveCV from "../../pages/ProjectsPages/InteractiveCV/InteractiveCV";
import OtherProjects from "../../pages/ProjectsPages/Others/OtherProjectsPage";
import TLOUPage from "../../pages/ProjectsPages/TLOU/TLOUPage";

const projectsPages = {
    1: TBA,
    2: CastleFlipper,
    3: TankSquad,
    4: TLOUPage,
    5: ExtractionShooter,
    6: InteractiveCV,
    7: OtherProjects,
};

export default projectsPages;

// RYBNIK
// I worked on a big interactive project which consists almost of 90 small applications dedicated to the human organism and medicine.

// https://i.postimg.cc/sx1grhsN/Rybnik.png

// 06.2021-04.2022
// rb

// NBP
// "Developed an application for the Polish National Bank dedicated to Jan Paweł II's anniversary, which was presented in the National polish museum of money.
// https://i.postimg.cc/ZqhndnxW/NBP.png
// nbp

// AIRLINE
// https://store.steampowered.com/app/1366730/Airline_Technician/
// https://i.postimg.cc/rpCmCTfQ/Airline.png
// al
// 08.2020-12.2020
